module.exports = __webpack_public_path__ + "img/469.2aa2a2ef.png";